import { createValidation } from '../../../utils/validation';
export const createComplaintFindingTypeValidation = (fields) => { const validation = createValidation(fields); return { schema: validation.schema, validateData: validation.validateData, validateComplaintFindingTypeData: validation.validateData, validateField: validation.validateField }; };
export default createComplaintFindingTypeValidation;

